import { getBuildingGroupProfilePathname } from '../../utils/link'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../utils/massActions'

import {
  BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP,
  BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP_MASS,
  BUILDING_GROUPS_ACTION_EDIT_BUILDINGS,
  BUILDING_GROUPS_ACTION_EDIT_BUILDINGS_MASS,
  BUILDING_GROUPS_ACTION_EDIT_MANAGERS,
  BUILDING_GROUPS_ACTION_EDIT_MANAGERS_MASS,
  BUILDING_GROUPS_ACTION_REMOVE,
  BUILDING_GROUPS_ACTION_REMOVE_MASS,
} from './BuildingGroup.constants'

export function toBuildingGroupSelectItem(item) {
  return {
    ...(item.avatar ? { avatar: { src: item.avatar } } : null),
    label: item.name,
    value: item.id,
  }
}

export function toBuildingGroupSelectItems(
  items,
  mapper = toBuildingGroupSelectItem
) {
  return items.map(mapper)
}

export function getBuildingGroupCreationSuccessNotification({
  data,
  isBuildingGroupProfileNGAvailable,
  t,
}) {
  return {
    linkProps: {
      reloadDocument: true,
      title: t('Notification.BuildingGroupСeatedViewLinkKey'),
      to: getBuildingGroupProfilePathname({
        id: data.id,
        isBuildingGroupProfileNGAvailable,
      }),
    },
    text: t('BuildingGroup.CreateBuildingGroupTextNotificationKey', {
      title: data.name,
    }),
    title: t('BuildingGroup.CreateBuildingGroupNotificationTitleKey'),
  }
}

export function getBuildingGroupTableMassActions({
  permissions,
  t,
  withDeleteFromGroup = false,
}) {
  const items = [
    {
      label: t('BuildingGroups.EditManagersActionOptionKey'),
      permission: permissions.can_edit_responsible_users,
      value: BUILDING_GROUPS_ACTION_EDIT_MANAGERS_MASS,
    },
    {
      label: t('BuildingGroups.EditBuildingsActionOptionKey'),
      permission: permissions.can_edit_buildings,
      value: BUILDING_GROUPS_ACTION_EDIT_BUILDINGS_MASS,
    },
    null,
    {
      label: t('BuildingGroups.DeleteFromGroupActionOptionKey'),
      permission: withDeleteFromGroup && permissions.can_edit_buildings,
      value: BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP_MASS,
    },
    {
      label: t('BuildingGroups.RemoveActionOptionKey'),
      permission: permissions.can_delete,
      value: BUILDING_GROUPS_ACTION_REMOVE_MASS,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getBuildingGroupTableItemActions({
  item: { permissions },
  withDeleteFromGroup = false,
}) {
  const items = [
    {
      label: 'BuildingGroups.EditManagersActionOptionKey',
      permission: permissions.can_edit_responsible_users,
      value: BUILDING_GROUPS_ACTION_EDIT_MANAGERS,
    },
    {
      label: 'BuildingGroups.EditBuildingsActionOptionKey',
      permission: permissions.can_edit_buildings,
      value: BUILDING_GROUPS_ACTION_EDIT_BUILDINGS,
    },
    null,
    {
      label: 'BuildingGroups.DeleteFromGroupActionOptionKey',
      permission: withDeleteFromGroup && permissions.can_edit_buildings,
      value: BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP,
    },
    {
      label: 'BuildingGroups.RemoveActionOptionKey',
      permission: permissions.can_delete,
      value: BUILDING_GROUPS_ACTION_REMOVE,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}

export function getBuildingGroupTableNotificationTitle({
  action,
  count,
  t,
  totalCount,
}) {
  const types = {
    [BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP]: t(
      'Notification.BuildingGroupsTitleDeletedFromGroupKey'
    ),
    [BUILDING_GROUPS_ACTION_DELETE_FROM_GROUP_MASS]: t(
      'Notification.BuildingGroupsTitleMassDeletedFromGroupKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDING_GROUPS_ACTION_EDIT_BUILDINGS]: t(
      'Notification.BuildingGroupsTitleEditedBuildingsKey'
    ),
    [BUILDING_GROUPS_ACTION_EDIT_BUILDINGS_MASS]: t(
      'Notification.BuildingGroupsTitleMassEditedBuildingsKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDING_GROUPS_ACTION_EDIT_MANAGERS]: t(
      'Notification.BuildingGroupsTitleEditedManagersKey'
    ),
    [BUILDING_GROUPS_ACTION_EDIT_MANAGERS_MASS]: t(
      'Notification.BuildingGroupsTitleMassEditedManagersKey',
      {
        count,
        totalCount,
      }
    ),
    [BUILDING_GROUPS_ACTION_REMOVE]: t(
      'Notification.BuildingGroupsTitleRemovedKey'
    ),
    [BUILDING_GROUPS_ACTION_REMOVE_MASS]: t(
      'Notification.BuildingGroupsTitleMassRemovedKey',
      {
        count,
        totalCount,
      }
    ),
  }

  return types[action] || null
}

export function getBuildingGroupTableAsyncNotificationText({ action, t }) {
  const types = {
    [BUILDING_GROUPS_ACTION_REMOVE]: t(
      'Notification.BuildingGroupsAsyncTextRemovedKey'
    ),
    [BUILDING_GROUPS_ACTION_REMOVE_MASS]: t(
      'Notification.BuildingGroupsAsyncTextMassRemovedKey'
    ),
  }

  return types[action] || null
}
